import { FormValues, selectedDimensionValues } from "components";
import { AssortmentType } from "containers/folders/types/base";
import { IAllocationDimension } from "helpers/allocation-dimension";
import isEmpty from "lodash/isEmpty";

export const parseSelectedDimensionsIntoExcluded = (
    selectedDimensions: selectedDimensionValues,
    merchantDimensions: IAllocationDimension[]
) =>
    merchantDimensions.reduce(
        (acc, dimension) => ({
            ...acc,
            [dimension.id]: dimension.dimension_values
                .filter((dimensionValue) => !selectedDimensions[dimension.id].includes(dimensionValue.id))
                .map((dimensionValue) => dimensionValue.id),
        }),
        {} as Record<string, string[]>
    );

export const createInitialFormValues = (merchantDimensions: IAllocationDimension[]): FormValues => {
    const dimensionsValues = merchantDimensions.reduce((acc, dimension, index) => {
        // this logic is necessary to de-select all values for deliveries but only deliveries
        const vendorHasOnlyOneDimension = merchantDimensions.length === 1;

        return {
            ...acc,
            [dimension.id]:
                vendorHasOnlyOneDimension || index >= 1 ? dimension.dimension_values.map((dv) => dv.id) : [],
        };
    }, {} as selectedDimensionValues);

    return {
        assortmentType: AssortmentType.External,
        dimensionsValues,
    };
};

const isNotExternalAssortment = (assortmentType: AssortmentType) => assortmentType !== AssortmentType.External;

const validateDimensionsRule = (formValues: FormValues): boolean => {
    if (!formValues?.dimensionsValues) {
        return true;
    }
    const valuesList = Object.values(formValues.dimensionsValues);

    return valuesList.every((selectedValues) => selectedValues.length);
};

const validateBrandRule = (formValues: FormValues): boolean =>
    undefined !== formValues.assortmentType && isNotExternalAssortment(formValues.assortmentType)
        ? true
        : Boolean(formValues.brandId);

const validateAssortmentName = (formValues: FormValues): boolean => (isEmpty(formValues.assortmentName) ? false : true);

const formValidationRules = [validateDimensionsRule, validateBrandRule, validateAssortmentName];

export const isFormValid = (formValues: FormValues): boolean => formValidationRules.every((rule) => rule(formValues));
